
import SecondLaneLogo from "./assets/LogoMobile.svg?url";
import TopQR from "./assets/QRMoblie.svg?url";
import BottomQR from "./assets/QRbottomMobile.svg";
import Frame1472 from "./assets/Frame 1472.svg";

import Group1 from "./assets/Group1.webp";
import Group2 from "./assets/Group2.webp";
import Group3 from "./assets/Group3.webp";
import Group4 from "./assets/Group4.webp";
import Group5 from "./assets/Group5.webp";
import iPhone16ProMock1 from "./assets/iPhone16ProMock1.webp";

export const MobilePWALandingScreen = (): JSX.Element => {
  const features = [
    {
      title: "Buy and Sell",
      description: "Browse live secondary listings and place bids on top private deals. Find the best prices to get liquidity on your assets",
      image: Group1,
      imagePosition: "right" as const,
    },
    {
      title: "Track your holdings", 
      description: "Upload your portfolio to trace value, structure, vesting, and performance over time",
      image: Group2,
      imagePosition: "left" as const,
    },
    {
      title: "Make informed decisions",
      description: "Explore funding round data, token unlocks, cap tables, and investor participation over 5k+ top projects",
      image: Group3, 
      imagePosition: "right" as const,
    },
    {
      title: "Get notified on assets of your choice",
      description: "Receive push notifications on real-time activity across your watched assets and portfolios.",
      image: Group4,
      imagePosition: "left" as const,
    },
    {
      title: "Everything in one place",
      description: "No more chats, screenshots, or spreadsheet chaos. One tool built for investors and founders.",
      image: Group5,
      imagePosition: "right" as const,
    },
  ];

  const stats = [
    { value: "$5B+", description: "in live secondary market dealflow" },
    { value: "10,000+", description: "strong network of active Web3 investors and founders" },
    { value: "100%", description: "compliant platform trusted by institutions" },
  ];

  return (
    <div className="w-full bg-[#56584F]" style={{ fontFamily: "'SFT Schrifted Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif" }}>
      {/* Mobile Hero Section */}
      <section className="min-h-screen flex relative">
        {/* Content */}
        <div className="flex-1 px-6 py-12 flex flex-col">
          {/* Logo - independent block */}
          <div className="flex justify-center mb-16" style={{ marginTop: '0px' }}>
            <img
              src={SecondLaneLogo}
              alt="SecondLane Logo"
              className="w-72 h-auto"
              style={{ maxWidth: '100%' }}
            />
          </div>
          
                      {/* Text content - independent block */}
          <div className="flex-1 flex flex-col justify-center" style={{ marginTop: '-60px' }}>
            <div className="space-y-8">
              <h1 className="text-white uppercase" style={{ 
                fontFamily: "'SFT Schrifted Sans TRIAL', 'SFT Schrifted Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
                fontWeight: 900,
                fontSize: '48px',
                lineHeight: '100%',
                letterSpacing: '0%'
              }}>
                WEB3 PRIVATE MARKETS <br />
                IN YOUR PHONE
              </h1>
              
              <p className="text-white" style={{ 
                fontFamily: "'SFT Schrifted Sans TRIAL Var', 'SFT Schrifted Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
                fontWeight: 279,
                fontSize: '24px',
                lineHeight: '100%',
                letterSpacing: '0%'
              }}>
                Your all-in-one secondary market tool: access top buy and sell Web3 deals, 
                track your holdings, and monitor project data, all in one secure app.
              </p>
            </div>
          </div>
          
                        {/* QR Code - independent block */}
          <div className="flex flex-col items-center justify-center" style={{ marginTop: '20px' }}>
            <a 
              href="https://pwa.secondlane.io" 
              target="_blank" 
              rel="noopener noreferrer"
              className="cursor-pointer transition-transform hover:scale-105 flex flex-col items-center"
            >
              <img
                src={TopQR}
                alt="Download QR Code"
                className="w-60 h-60"
                style={{ maxWidth: '80%' }}
              />
            </a>
            <p className="text-white text-sm text-center mt-2" style={{ fontFamily: "'SFT Schrifted Sans TRIAL', 'SFT Schrifted Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
            fontWeight: 400,
            fontSize: '16px',
            lineHeight: '120%',
            letterSpacing: '0%' }}>
              Tap or scan to download<br />
              SecondLane App
            </p>
          </div>
        </div>
      </section>

              {/* Frame1472 separator between first and second sections */}
      <div className="w-full">
        <img
          src={Frame1472}
          alt="Section Divider"
          className="w-full h-auto"
        />
      </div>

      {/* Mobile Features Section */}
      <section className="bg-white px-6 py-16">
        {/* Section Header */}
        <div className="mb-12 relative">
          <div className="absolute w-20 h-20 -left-10 top-0 bg-[#e3fd5a]" />
          <h2 className="text-[#161616] relative z-10" style={{ 
            fontFamily: "'SFT Schrifted Sans TRIAL', 'SFT Schrifted Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
            fontWeight: 900,
            fontSize: '48px',
            lineHeight: '100%',
            letterSpacing: '0%'
          }}>
            Spot hot opportunities. <br />
            Find the best prices for your portfolio.
          </h2>
          <p className="text-black mt-12" style={{ 
            fontFamily: "'SFT Schrifted Sans TRIAL Var', 'SFT Schrifted Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
            fontWeight: 279,
            fontSize: '24px',
            lineHeight: '100%',
            letterSpacing: '0%'
          }}>
            Your all-in-one secondary market tool: access top buy and sell Web3 deals, 
            track your holdings, and monitor project data, all in one secure app.
          </p>
        </div>

                  {/* iPhone under functions heading */}
        <div className="flex justify-center mb-16">
          <img
            src={iPhone16ProMock1}
            alt="iPhone 16 Pro Mockup"
            className="w-80 h-auto"
            style={{ maxWidth: '100%' }}
          />
        </div>

        {/* Features List */}
        <div className="space-y-16">
          {features.map((feature, index) => (
            <div key={index} className="flex flex-col items-center gap-8">
              <div className="space-y-6 text-left w-full">
                <h3 className="text-[#56584f]" style={{ 
                  fontFamily: "'SFT Schrifted Sans TRIAL', 'SFT Schrifted Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
                  fontWeight: 700,
                  fontSize: '36px',
                  lineHeight: '100%',
                  letterSpacing: '0%'
                }}>
                  {feature.title}
                </h3>
                <p className="text-black" style={{ 
                  fontFamily: "'SFT Schrifted Sans TRIAL Var', 'SFT Schrifted Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
                  fontWeight: 279,
                  fontSize: '24px',
                  lineHeight: '100%',
                  letterSpacing: '0%'
                }}>
                  {feature.description}
                </p>
              </div>
              
              <div className="w-full">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-auto object-contain"
                  style={{ maxWidth: '100%' }}
                />
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Frame1472 as separator between sections */}
      <div className="w-full">
        <img
          src={Frame1472}
          alt="Section Separator"
          className="w-full h-auto"
        />
      </div>

      {/* Video Section */}
      <section className="bg-white px-6 py-16">
        <div className="space-y-8">
          <h2 className="text-[#56584f] text-center" style={{ 
            fontFamily: "'SFT Schrifted Sans TRIAL', 'SFT Schrifted Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
            fontWeight: 700,
            fontSize: '36px',
            lineHeight: '100%',
            letterSpacing: '0%'
          }}>
            See SecondLane App in action
          </h2>
          
          <div className="w-full max-w-2xl mx-auto">
            <video
              className="w-full h-auto rounded-lg shadow-lg"
              controls
              preload="metadata"
            >
              <source 
                src="https://d1yccqs7b7eo8o.cloudfront.net/c17fcd87-d535-43d5-bb4a-7dec5c9a8858#t=0.001"
                type="video/mp4" 
              />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </section>

      {/* Frame1472 as separator between video and stats sections */}
      <div className="w-full">
        <img
          src={Frame1472}
          alt="Section Separator"
          className="w-full h-auto"
        />
      </div>

      {/* Mobile Stats Section */}
      <section className="bg-[#56584f] px-6 py-16">
        <div className="space-y-8">
          <h2 className="font-black text-white text-4xl" style={{ fontWeight: 900, letterSpacing: '-0.02em' }}>
            Download the App to Tap Into:
          </h2>

          <div className="space-y-8">
            {stats.map((stat, index) => (
              <div key={index} className="space-y-2 text-left">
                <div className="font-bold text-[#e3fd5a] text-5xl" style={{ fontWeight: 700, letterSpacing: '-0.02em' }}>
                  {stat.value}
                </div>
                <div className="font-bold text-white text-2xl leading-tight" style={{ fontWeight: 600, letterSpacing: '-0.01em' }}>
                  {stat.description}
                </div>
              </div>
            ))}
          </div>

          {/* Compliance Note */}
          <div className="space-y-4 pt-6">
            <h3 className="font-normal text-white text-lg" style={{ fontWeight: 400, letterSpacing: '-0.01em' }}>
              Compliance Note
            </h3>
            <div className="space-y-2 text-white font-light text-sm leading-tight" style={{ fontWeight: 400, lineHeight: '1.3' }}>
              <p>The SecondLane App displays non-binding indications of interest and project information for informational purposes only.</p>
              <p>SecondLane works with a registered U.S. broker-dealer to facilitate compliant transaction workflows.</p>
              <p>All bids and offers shown are non-binding indications of interest. Users are responsible for conducting their own due diligence and ensuring compliance with local regulations.</p>
            </div>
          </div>

          <div className="text-center w-full">
            <div className="text-[#e3fd5a] font-bold text-4xl tracking-tight w-full" style={{ fontWeight: 700, letterSpacing: '-0.02em', width: '100%', textAlign: 'center' }}>
              SecondLane
            </div>
          </div>
        </div>
      </section>

      {/* Mobile Download Section */}
      <section className="bg-[#e3fd5a] px-6 py-16">
        <div className="flex flex-col items-center gap-8">
          <h2 className="font-bold text-[#56584f] text-2xl text-center" style={{ fontWeight: 700, letterSpacing: '-0.02em' }}>
            Download SecondLane App
          </h2>
          <a 
            href="https://pwa.secondlane.io" 
            target="_blank" 
            rel="noopener noreferrer"
            className="cursor-pointer transition-transform hover:scale-105"
          >
            <img
              src={BottomQR}
              alt="Download QR Code"
              className="w-40 h-40"
            />
          </a>
        </div>
      </section>
    </div>
  );
};

export default MobilePWALandingScreen; 